<template>
	<el-dialog 
		title="红包领取记录" 
		:visible.sync="visible" 
		width="520px" 
		:close-on-click-modal="false"
		@close="onClose"
		custom-class="red-packet-records-dialog">
		<div class="red-packet-records">
			<!-- 红包信息头部 -->
			<div class="packet-header">
				<div class="header-icon">🧧</div>
				<div class="header-info">
					<div class="packet-message">{{ packetTypeDesc }}</div>
					<div class="packet-stats">
						<span>共{{ totalCount }}个</span>
						<span class="separator">·</span>
						<span>{{ totalAmount }}U</span>
					</div>
				</div>
			</div>

			<!-- 领取记录列表 -->
			<div class="records-list">
				<div v-if="records.length === 0" class="empty-state">
					<div class="empty-icon">📭</div>
					<p class="empty-text">暂无领取记录</p>
				</div>

				<div v-else>
					<div v-for="(record, index) in records" :key="index" class="record-item">
						<div class="user-avatar">
							<head-image :url="record.receiverAvatar" :name="record.receiverName" :size="40"></head-image>
						</div>
						<div class="user-info">
							<div class="user-name">
								{{ record.receiverName }}
								<el-tag v-if="record.isBestLuck === 1" size="mini" type="warning">🎉 手气最佳</el-tag>
							</div>
							<div class="receive-time">{{ formatTime(record.receiveTime) }}</div>
						</div>
						<div class="receive-amount">{{ record.amount }}U</div>
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: 'RedPacketRecords',
	components: {
		HeadImage
	},
	data() {
		return {
			visible: false,
			records: [],
			packetTypeDesc: '',
			totalCount: 0,
			totalAmount: 0
		}
	},
	methods: {
		open(records, packetInfo) {
			console.log('[red-packet-records] 打开领取记录，records:', records);
			console.log('[red-packet-records] packetInfo:', packetInfo);
			
			this.records = records || [];
			this.packetTypeDesc = packetInfo?.packetTypeDesc || '红包';
			this.totalCount = packetInfo?.totalCount || 0;
			this.totalAmount = packetInfo?.totalAmount || 0;
			
			console.log('[red-packet-records] 处理后的 records:', this.records);
			
			this.visible = true;
		},
		onClose() {
			this.visible = false;
			this.reset();
		},
		reset() {
			this.records = [];
			this.packetTypeDesc = '';
			this.totalCount = 0;
			this.totalAmount = 0;
		},
		formatTime(timestamp) {
			if (!timestamp) return '';
			
			const date = new Date(timestamp);
			const now = new Date();
			const diff = now - date;
			
			// 小于1分钟
			if (diff < 60000) {
				return '刚刚';
			}
			
			// 小于1小时
			if (diff < 3600000) {
				const minutes = Math.floor(diff / 60000);
				return `${minutes}分钟前`;
			}
			
			// 小于24小时
			if (diff < 86400000) {
				const hours = Math.floor(diff / 3600000);
				return `${hours}小时前`;
			}
			
			// 今年
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hour = String(date.getHours()).padStart(2, '0');
			const minute = String(date.getMinutes()).padStart(2, '0');
			
			if (year === now.getFullYear()) {
				return `${month}-${day} ${hour}:${minute}`;
			}
			
			// 不是今年
			return `${year}-${month}-${day}`;
		}
	}
}
</script>

<style lang="scss" scoped>
.red-packet-records {
	min-height: 300px;
	max-height: 500px;

	.packet-header {
		display: flex;
		align-items: center;
		gap: 15px;
		padding: 20px;
		background: linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 100%);
		border-radius: 12px;
		margin-bottom: 20px;

		.header-icon {
			font-size: 48px;
		}

		.header-info {
			flex: 1;

			.packet-message {
				font-size: 16px;
				font-weight: 600;
				color: #333;
				margin-bottom: 8px;
			}

			.packet-stats {
				font-size: 13px;
				color: #666;

				.separator {
					margin: 0 8px;
					color: #999;
				}
			}
		}
	}

	.records-list {
		max-height: 350px;
		overflow-y: auto;

		.empty-state {
			text-align: center;
			padding: 60px 20px;
			
			.empty-icon {
				font-size: 48px;
				margin-bottom: 12px;
				opacity: 0.5;
			}

			.empty-text {
				color: #999;
				font-size: 14px;
				margin: 0;
			}
		}

		.record-item {
			display: flex;
			align-items: center;
			gap: 12px;
			padding: 12px 8px;
			border-bottom: 1px solid #f5f5f5;
			transition: background 0.2s ease;

			&:hover {
				background: #f9f9f9;
			}

			.user-avatar {
				flex-shrink: 0;
			}

			.user-info {
				flex: 1;
				min-width: 0;

				.user-name {
					font-size: 14px;
					color: #333;
					font-weight: 500;
					display: flex;
					align-items: center;
					gap: 8px;
				}

				.receive-time {
					font-size: 12px;
					color: #999;
					margin-top: 4px;
				}
			}

			.receive-amount {
				font-size: 16px;
				font-weight: 600;
				color: #ff5722;
				flex-shrink: 0;
			}
		}
	}
}
</style>

